import { hsl } from 'polished';
export default {
    /** Hex: #333333 */
    black: '#333333',
    /** Hex: #fff */
    white: '#fff',
    /** Hex: #000 */
    fullBlack: '#000',
    blue: {
        /** Hex: #A9BCE1 */
        base: '#A9BCE1',
        /** Hex: #E5EBF6 */
        light: '#E5EBF6',
        /** Hex: #F6F8FC */
        tint: '#F6F8FC',
    },
    yellow: {
        /** Hex: #FCEF82 */
        base: '#FCEF82',
        /** Hex: #FEFAD9 */
        light: '#FEFAD9',
        /** Hex: #FFFDF3 */
        tint: '#FFFDF3',
    },
    orange: {
        /** Hex: #E9A353 */
        base: '#E9A353',
        /** Hex: #F8E3CB */
        light: '#F8E3CB',
        /** Hex: #FDF6EE */
        tint: '#FDF6EE',
    },
    green: {
        /** Hex: #69B6AB */
        base: '#69B6AB',
        /** Hex: #D1E9E6 */
        light: '#D1E9E6',
        /** Hex: #F0F8F7 */
        tint: '#F0F8F7',
        /** Hex: #326F68 */
        link: '#326F68',
    },
    grey: {
        /** Hex: #1D1D1D */
        grey11: hsl(0, 0, 0.11),
        /** Hex: #222222 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #292929 */
        grey16: hsl(0, 0, 0.16),
        /** Hex: #585858 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #595959 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #666666 */
        grey40: hsl(0, 0, 0.4),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #A0A0A0 */
        grey63: hsl(0, 0, 0.63),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #EFEFEF */
        grey94: hsl(0, 0, 0.94),
        /** Hex: #F7F7F7 */
        grey97: hsl(0, 0, 0.97),
    },
    validation: {
        /** Hex: #F50E12 */
        red: '#F50E12',
    },
};
